import { Box } from '@rbilabs/universal-components';

export const FormContainer = Box.withConfig({
  marginTop: 2,
  marginX: 2,
});

export const LabelContainer = Box.withConfig<{ $alignItems?: string }>(p => ({
  marginLeft: 3,
  alignItems: p.$alignItems || 'center',
  flex: 1,
}));
